export default "__VITE_ASSET__DF7OE1Cu__"